import React, { useContext } from 'react';
import AddIcon from '@material-ui/icons/Add';
import { ActivatorComponent } from '../../../../components/datawaiting/ActivatorComponent';
import { IUploadElementService } from '../../../../services/upload/Interfaces';
import { MediaList } from './MediaList';
import { BreadCrumbItem, PbBlockContainer, PbHeader2, PbParagraph, PbUploadButton } from '../../../../components/pd_themed';
import { style } from 'typestyle';
import { TextStrings } from '../../../../lang/TextStrings';
import { useDeviceContext } from '../../../main/AppLayout';
import { useCustomerContext } from '../UseCustomer';

const blockStyle = style({
    gridColumn: " 1/ span 2"
});

const containerStyle = style({
    display: "grid",
    gridTemplateRows: "min-content min-content min-content 1fr",
    gridRowGap: "10px",
    overflow: "hidden"
});

const buttonStyle = style({
    display: "grid",
    gridTemplateColumns: "auto min-content",
    gridTemplateRows: "1fr",
    alignItems: "center"
});

export function MediaRoute(): JSX.Element {
    return (
        <>
            <BreadCrumbItem key="Media" title="Media" />
            <MediaBlock />
        </>
    )
}

export function MediaBlock(): JSX.Element | null {
    const customerContext = useCustomerContext();
    const deviceContext = useDeviceContext();
    return customerContext && deviceContext ? (
        <PbBlockContainer className={blockStyle} span={2}>
            <div className={containerStyle}>
                <PbHeader2>{TextStrings.textMyMedia}</PbHeader2>
                <ActivatorComponent activator={customerContext.uploadElementServiceActivator} content={(uploadElementService) => (
                    <>
                        <PbParagraph>{TextStrings.textMyMediaUploadDesc}</PbParagraph>
                        <PbUploadButton className={buttonStyle} onFilesSelected={(files) => addMedia(files, uploadElementService)} accept="image/*,video/*" multiple={true} >
                            {TextStrings.textMyMediaAddAction}<AddIcon />
                        </PbUploadButton>
                    </>
                )}
                />
                <ActivatorComponent activator={customerContext.elementServiceActivator}
                    content={(elementService) => (
                        <MediaList
                            customer={customerContext}
                            deviceContext={deviceContext}
                            elementService={elementService.listEditService}
                        />
                    )}
                />
            </div>
        </PbBlockContainer>
    ) : null;

    function addMedia(files: FileList, uploadElementService: IUploadElementService) {
        uploadElementService.addFiles(files);
    }
}